import { render } from "./PageLoader.vue.ts?vue&type=template&id=a5b18cc3&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PageLoader.vue?vue&type=template&id=a5b18cc3&ts=true"
import script from "./PageLoader.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageLoader.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PageLoader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/ui/loaders/PageLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5b18cc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5b18cc3', __exports__)) {
    api.reload('a5b18cc3', __exports__)
  }
  
  module.hot.accept("./PageLoader.vue.ts?vue&type=template&id=a5b18cc3&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PageLoader.vue?vue&type=template&id=a5b18cc3&ts=true", () => {
    api.rerender('a5b18cc3', render)
  })

}


export default __exports__